import React, { useEffect, useMemo, useState } from "react";
import * as S from "./BillingTable.style";
import { useTranslation } from "react-i18next";

// GraphQL
import { useQuery } from "@apollo/client";

// components
import ZaiaReaction from "../../../../../../zaiaComponents/zaiaReaction";

// pipes
import { QUERY_GET_DOCTOR_BILLING_BY_DATES } from "../../../../../../../graphql/queries/DoctorBilling";
import { QUERY_GET_DOCTORS_DATA } from "../../../../../../../graphql/queries/Doctor";
import { QUERY_GET_PROCESS_TYPES } from "../../../../../../../graphql/queries/Process";
import useDoctorData from "../../../../../../../hooks/useDoctorData";

// assets
const zaiaError = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;
const zaiaLoad = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;

const ENV = process.env.REACT_APP_ENV;

function Billing({
  month, 
  year,
  setBillingList,
  doctorIds
}) {
  const {t, i18n: { language } } = useTranslation("global");
  const {doctorData} = useDoctorData();
  const { data: processTypes } = useQuery(QUERY_GET_PROCESS_TYPES);

  const { 
    data: doctorBillingData, 
    loading: doctorBillingLoading, 
    error: doctorBillingError
  } = useQuery(
    QUERY_GET_DOCTOR_BILLING_BY_DATES, 
    { 
      variables: { 
        initialDate: new Date(year, month, 1, 0, 0, 0, 0),
        finalDate: new Date(year, month + 1, 0, 23, 59, 59, 999),
        doctorsIds: doctorIds
      },
    },
  );  

  useEffect(() => {
    if (doctorBillingData?.doctorBilling) {
      setBillingList(doctorBillingData.doctorBilling);
    }
  }, [doctorBillingData, setBillingList]);

  if (doctorBillingLoading) 
    return (
      <S.BillingTableDiv>
        <ZaiaReaction
          widthimg="150px"
          zaiaImg={zaiaLoad}
        />  
      </S.BillingTableDiv>
    );

  if (doctorBillingLoading) 
    return (
      <S.BillingTableDiv>
        <ZaiaReaction
          zaiaImg={zaiaError}
          widthimg="125px"
          text={t("profile.errorInfo")}
          sizeText="17px"
          widthText="240px"
        />
      </S.BillingTableDiv>
    );

  return (
    <S.BillingTableDiv>
      <table>
        <thead>
          <tr>
            <th>{t("billing.patientId")}</th>
            <th>{t("billing.patientName")}</th>
            <th>{t("billing.daysOfData")}</th>
            <th>{t("billing.minutesLogged")}</th>
            <th>{t("billing.nurseStaff")}</th>
            <th>{t("billing.nurseStaffId")}</th>
            <th>{t("billing.description")}</th>
            <th>{t("billing.provider")}</th>
            <th>{t("billing.address")}</th>
            <th>{t("billing.birthDate")}</th>
            <th>{t("billing.phone")}</th>
            <th>{t("billing.securityCode")}</th>
          </tr>
        </thead>
        <tbody>
          {
            doctorBillingData?.doctorBilling.map((billing, index) => (
              <tr key={index}>
                <td>{billing.userId}</td>
                <td>{billing.patientName}</td>
                <td>{billing.daysOfData}</td>
                <td>{(billing.durationLogged / 60).toFixed(2)}</td>
                <td>{billing.doctorName}</td>
                <td>{billing.doctorId}</td>
                <td>{billing.description}</td>
                <td>{billing.provider}</td>
                <td>{billing.address}</td>
                <td>{billing.birthdate}</td>
                <td>{billing?.country?.phonecode} {billing.phone}</td>
                <td>{billing.securityCode}</td>
              </tr>
            ))
          }
        </tbody>
      </table>
    </S.BillingTableDiv>
  );
}


export default Billing;
